import React from 'react';
import { connect } from 'react-redux';
import '../ManagePurchaseAndRenewals.scss';
import CheckUser from './CheckUser';
import AddItems from './AddItems/AddItems';
import Membership from './Membership/Membership';
import RenewMembership from './RenewMembership/RenewMembership';
import Subscription from './Subscription/Subscription';
import RenewSubscription from './RenewSubscription/RenewSubscription';
import ProductOrder from './ProductOrder/ProductOrder';
import Donation from './Donation/Donation';
import Checkout from './Checkout/Checkout';
import Success from './Checkout/Success';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
    changeView,
    removePurchaseItem
} from '../../../../../../Redux/Actions/Admin/ManagePurchaseAndRenewalsActions';
import AdditionalDues from './AdditionalDues/AdditionalDues';

class PurchaseContainer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            modalOpen: false,
            total: 0,
            showSidebar: true
        }
    }

    componentDidMount() {
        this.setTotal();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.purchaseAndRenewals.purchaseList !== this.props.purchaseAndRenewals.purchaseList) {
            this.setTotal();
        }
    }

    setTotal = () => {
        var totalAmount = 0;
        for (var i = 0; i < this.props.purchaseAndRenewals.purchaseList.length; i++) {
            let p = this.props.purchaseAndRenewals.purchaseList[i];
            totalAmount = Number(Number(Number(p.SuggestedCost) + Number(totalAmount)));
        }

        this.setState({
            total: Number(totalAmount).toFixed(2)
        })
    }

    setTotalFromCheckout = (total) => {
        this.setState({
            total: Number(total).toFixed(2)
        })
    }

    itemName = (item) => {
        if (item.view === "RenewMembership") {
            return "Renew Membership"
        } else if (item.view === "RenewSubscription") {
            return "Renew Subscription"
        } else if (item.view === "ProductOrder") {
            return "Product Order"
        } else if (item.view === "AdditionalDues") {
            return "Additional Dues"
        } else {
            return item.view
        }
    }

    hideSidebar = () => {
        this.setState({
            showSidebar: false
        })
    }
   

    render() {
        return (
            <div className="purchaseAndRenewals">
                <i className="fas fa-times prModalClose" onClick={this.props.modalToggle}></i>
                <h3>ADD PURCHASE / RENEWAL TRANSACTION</h3>
                <div className="row">
                    <div className="col-md-9">
                        {this.props.purchaseAndRenewals.view === "CheckUser" ? <CheckUser /> : ""}
                        {this.props.purchaseAndRenewals.view === "AddItems" ? <AddItems /> : ""}
                        {this.props.purchaseAndRenewals.view === "Membership" ? <Membership /> : ""}
                        {this.props.purchaseAndRenewals.view === "RenewMembership" ? <RenewMembership /> : ""}
                        {this.props.purchaseAndRenewals.view === "Subscription" ? <Subscription /> : ""}
                        {this.props.purchaseAndRenewals.view === "RenewSubscription" || this.props.purchaseAndRenewals.view === "Renew Subscription" ? <RenewSubscription /> : ""}
                        {this.props.purchaseAndRenewals.view === "ProductOrder" ? <ProductOrder /> : ""}
                        {this.props.purchaseAndRenewals.view === "Donation" ? <Donation /> : ""}
                        {this.props.purchaseAndRenewals.view === "AdditionalDues" ? <AdditionalDues/> : ""}
                        {this.props.purchaseAndRenewals.view === "Checkout" ? <Checkout refreshGrid={this.props.refreshGrid} updateSuggestTotal={this.setTotalFromCheckout}/> : ""}
                        {this.props.purchaseAndRenewals.view === "Success" ? <Success modalToggle={this.props.modalToggle} hideSidebar={() => this.hideSidebar()}/> : ""}                        
                    </div>
                    <div className="col-md-3 sideBar">
                        {this.props.purchaseAndRenewals.purchaseList.length > 0 && this.state.showSidebar ?
                            <ul className="purchaseList">
                                {
                                    this.props.purchaseAndRenewals.purchaseList.map((item, index) => {
                                        item.id = index;
                                        return (
                                            <li className="purchaseListItem" key={index} onClick={
                                                (event) => {
                                                    this.props.changeView(item)
                                                }}
                                            >
                                                <div className="row">
                                                    <div className="col-md-8">
                                                        <span><FontAwesomeIcon icon="plus" /></span>{this.itemName(item)} - {item.Name} {item.organizationName !== undefined ? " - " + item.organizationName : ""}
                                                    </div>
                                                    <div className="col-md-4 right">
                                                        <p className="inlineBlock">${Number(item.SuggestedCost).toFixed(2)} </p>
                                                        <span
                                                            className="closeBtn"
                                                            onClick={(event) => {
                                                                event.stopPropagation()
                                                                this.props.removePurchaseItem(index);
                                                            }
                                                            }>
                                                            <FontAwesomeIcon icon="times" />
                                                        </span>
                                                    </div>
                                                </div>
                                            </li>
                                        )
                                    })
                                }
                            </ul> : ""
                        }
                        {this.props.purchaseAndRenewals.view === "CheckUser" || !this.state.showSidebar ? "" : <button onClick={() => this.props.changeView({ view: 'AddItems' })}>Add Item</button>}
                        {this.props.purchaseAndRenewals.view === "CheckUser" || !this.state.showSidebar ? "" :
                            <div className="sideBarTotal">
                                <h4>Suggested Total: ${this.state.total}</h4>
                                {this.props.purchaseAndRenewals.purchaseList.length > 0 ?
                                    <button className="checkoutBtn" onClick={() => this.props.changeView({ view: 'Checkout' })}>Checkout</button>
                                : ""}
                            </div>
                        }
                    </div>
                </div>
            </div>
        )
    }
}



function mapStateToProps(state) {
    return {
        purchaseAndRenewals: state.purchaseAndRenewals
    };
}

export default connect(mapStateToProps, {
    changeView,
    removePurchaseItem
})(PurchaseContainer);